<template>
  <div
    class="border-2 rounded-lg shadow-sm bg-white grid grid-rows-subgrid gap-4"
    :class="[{ 'border-gray-800': isSelected || pkg.selected, 'border-gray-200': !(isSelected || pkg.selected) }]"
    :style="{
      'grid-row': `span ${subGridRows}`,
    }"
  >
    <div class="flex flex-col justify-between items-start border-b-2 px-4 py-5 h-full">
      <span class="font-bold text-lg mb-5">{{ pkg.name }}</span>
      <portal-button
        v-tooltip="disableSelectButton ? 'Package already selected by another signatory' : ''"
        :color="isSelected || pkg.selected ? 'gray-bg' : 'primary'"
        @click.prevent="$emit('set-selected-package', pkg)"
        :disabled="disableSelectButton"
        class="w-full flex justify-center items-center mt-auto"
      >
        <ion-icon
          v-if="isSelected || pkg.selected"
          name="checkmark-outline"
          class="text-white mr-2"
        ></ion-icon>
        <span class="font-bold">
          {{ isSelected || pkg.selected ? "Selected" : "Select" }}
        </span>
      </portal-button>
    </div>
    <template v-for="section in pkg.sections">
      <template v-if="isDepositFrequency(section)">
        <portal-billing-proposal-package-card-section
          :section="section"
          :is-deposit="true"
        />
        <portal-billing-proposal-package-card-section
          :section="section"
          :is-balance="true"
        />
      </template>
      <template v-else>
        <portal-billing-proposal-package-card-section :section="section" />
      </template>
    </template>
  </div>
</template>

<script>
import currencyUtils from "../../../js/helpers/currencyUtils"
import PortalButton from "../../../ClientPortal/UI/PortalButtons/PortalButton.vue"
import PortalBillingProposalPackageCardSection from "./PortalBillingProposalPackageCardSection.vue"

export default {
  name: "PortalBillingProposalPackageCard",
  components: { PortalBillingProposalPackageCardSection, PortalButton },
  emits: ["set-selected-package"],
  props: {
    pkg: {
      required: true,
    },
    isSelected: {
      default: false,
      type: Boolean,
    },
    packageSelectedByOther: {
      type: Boolean,
      default: false,
    },
    subGridRows: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    disableSelectButton() {
      return this.packageSelectedByOther && !this.pkg.selected
    },
  },
  methods: {
    isDepositFrequency(section) {
      return section.frequency === "deposit"
    },

    serviceItems(section) {
      return section.items.filter((item) => !item.is_optional)
    },

    formatCurrency(value) {
      return currencyUtils.convertAndFormatCurrency(value)
    },
  },
}
</script>

<style scoped></style>
